import { createSlice } from '@reduxjs/toolkit';

export interface IJupyterState {
  value: Record<string, any>
}

const initialState: IJupyterState = {
  value: {}
};
export const jupyterSlice = createSlice({
  name: 'jupyter',
  initialState,
  reducers: {
    setJupyterUrl: (state, action) => {
      state.value = action.payload
    },
  }
});

export const { setJupyterUrl } = jupyterSlice.actions;
export default jupyterSlice.reducer;
